import { useMemo } from 'react';
import { useConnectors, useLogicBlocks } from '@morph-mapper/node-logic';
import { SchemaVariant } from '@morph-mapper/types';
import { getKeys } from '@morph-mapper/utils';
import { Nodes, Edges } from '../../molecules';

export const useGraphTypes = (variant: SchemaVariant) => {
  const { logicBlocks } = useLogicBlocks(variant);
  const { connectors } = useConnectors();

  /*
   * Initialize node and edge types from configuration constants.
   */
  const nodeTypes = useMemo(
    () =>
      getKeys(logicBlocks).reduce((acc, key) => {
        return {
          ...acc,
          [key]: Nodes[logicBlocks[key].node](),
        };
      }, {}),
    [logicBlocks]
  );

  const edgeTypes = useMemo(
    () =>
      getKeys(connectors).reduce((acc, key) => {
        return {
          ...acc,
          [key]: Edges[connectors[key].edge](),
        };
      }, {}),
    [connectors]
  );

  return { nodeTypes, edgeTypes };
};
